/* eslint-disable */
import backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';
import * as safeJson from '@bingads-webui/safe-json';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import errorViewTemplate from '@bingads-webui-static-legacy/uet/template/uploadConversions/errorView.pug';
import ErrorViewVM from '@bingads-webui-static-legacy/uet/viewmodel/uploadConversions/errorView';
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import setting from '@bingads-webui-static-legacy/instrumentation/campaignSchemaAndSetting';
import '@bingads-webui-static-legacy/instrumentation/instrumentation';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!uet');
var close = (function () {
  this.trigger('close');
}).asLoggingStart(setting.ACTIVITYNAME.ClickOnCloseInErrorView);
var showDetails = function () {
  this.ko_model.showDetails(true);
};
var view = backbone.View.extend({
  events: {
    'click .btn-close': close,
    'click .btn-details': showDetails
  },
  initialize: function (options) {
    this.options = options || ({});
    this.errorMessage = this.getFriendlyError(this.options.log) || i18n.getString(this.options.errorMsgKey || 'UnifiedEventTracking_UploadConversions_GenericError');
    this.detailLogs = this.generateLogContent(this.options.log);
    this.ko_model = new ErrorViewVM({
      hasDetails: this.detailLogs && this.detailLogs.length > 0
    });
    this.errorMessage = this.ko_model.hasDetails ? this.errorMessage + ' ' : this.errorMessage;
  },
  render: function () {
    this.$el.html(errorViewTemplate({
      i18n: i18n,
      errorMsg: this.errorMessage,
      logArr: this.detailLogs
    }));
    ko.applyBindings(this.ko_model, this.el);
    instrumentation.endActivity();
    return this;
  },
  generateLogContent: function (log) {
    var ret = [];
    var line = '';
    _.each(_.keys(_.pick(log, 'Date', 'TaskId', 'ExecutionId', 'Url', 'ErrorCode')), function (key) {
      line = key + ': ' + log[key];
      ret.push(line);
    });
    return ret;
  },
  getFriendlyError: function (log) {
    var errObj;
    if (log && log.responseText) {
      var resObj = safeJson.parseSync(log.responseText);
      if (resObj && resObj.Errors && resObj.Errors.length > 0) {
        errObj = _.first(i18nErrors.getODataErrors(resObj.Errors));
      } else if (resObj && resObj.value && resObj.value.length > 0) {
        errObj = _.first(i18nErrors.getODataErrors(resObj.value));
      }
      if (errObj) {
        this.options.log = _.extend({}, this.options.log, {
          ErrorCode: errObj.code
        });
        return errObj.message === errObj.code ? null : errObj.message;
      }
    }
    return null;
  },
  recoverBinding: function () {
    ko.cleanNode(this.el);
    this.undelegateEvents();
    this.delegateEvents();
    ko.applyBindings(this.ko_model, this.el);
    instrumentation.endActivity();
  }
});
export default view;

